import { useTranslation } from 'react-i18next';
import AnswerContainer from './answer-container';

function AssistantTypingIndicator() {
  const { t } = useTranslation();

  return (
    <AnswerContainer className="animate-enter">
      <div className="flex items-center gap-2 text-slate-500">
        <span className="inline-flex h-2 w-2 rounded-full bg-slate-400 animate-pulse" />
        {t('common.loading')}
      </div>
    </AnswerContainer>
  );
}

export default AssistantTypingIndicator;
